import React from 'react'
import '@@/css/not-found.css';
import { useRouteError } from 'react-router-dom';
import NotFoundBgSrc from '@@/img/not-found-img-bg.jpg';


export default function ErrorPage(){
    const error = useRouteError();
    return (
        <main className='not-found'>
               <section>
                    <img className="bg" alt="" src={NotFoundBgSrc}/>
                    <aside>
                        <h1>{error.status ||500}</h1>
                        <div className="msg-bg">
                            <h3>{error.statusText || "Unknown"}</h3>
                            <p>
                                {
                                    error.status === 404 && "The page you are looking for doesn't exist or an error occured, go back to the homepage."
                                }
                                {
                                     !error.status && error.toString()
                                }
                            </p>
                        </div>
                        <a href={`${process.env.PUBLIC_URL}/`}>
                            <button>HOMEPAGE</button>
                        </a>
                    </aside>
               </section>
           </main>
    )
}